import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { User } from '../../user/user';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly UserService = inject(User);
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const token = this.UserService.getCookie('access_token');
    if (token) {
      this.UserService.setUserFromCookie();

      return true;
    }
    this.router.navigate(['/login'], {});
    return false;
  }
}
